import { ReactComponent as Icon } from "../icons/document.svg";

const DocumentsStatus = ({color, wth, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, marginTop: "5px"})} onClick={clickFunc} />
    </div>
  );
};

export default DocumentsStatus;